const fortraders_pt = require('./4traders.json')
export default fortraders_pt